export default (location) => {
	const parsed = location.pathname
		.split("/", 3)
		.filter((part) => part.length > 0);
	return parsed;
};
